import { render, staticRenderFns } from "./ListBanners.vue?vue&type=template&id=60fe0f86"
import script from "./ListBanners.vue?vue&type=script&lang=js"
export * from "./ListBanners.vue?vue&type=script&lang=js"
import style0 from "./ListBanners.vue?vue&type=style&index=0&id=60fe0f86&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports